const ITEMS = [
    "Crisisinterventie Jeugd",
    "Crisisbegeleiding LVB",
    "De-escalatie & Veiligheid",
    "Snel Inzetbaar",
    "Structuur & Stabilisatie",
    "Gemeenten, Wmo & Instellingen",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <section className="overflow-hidden border-y border-line bg-sand-100/70 py-5">
            <div className="animate-marquee flex w-max items-center whitespace-nowrap">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="px-8 font-serif text-lg italic text-moss-800/75 sm:text-xl">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rounded-full bg-terracotta/60" />
                    </span>
                ))}
            </div>
        </section>
    );
}
